import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { PATTERN_PATH, getPatternById, updatePattern } from '../../api/patternApi';
import { useApiProgress } from '../../hooks/ApiProgress';
import { updatePatternAction } from '../../redux/feature/patternSlice';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';

const PatternEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [pattern, setPattern] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${PATTERN_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${PATTERN_PATH}`, false)

    useEffect(() => {
        getPatternById(id).then(res => setPattern(res.data))
    }, [id])

    const onClickSubmit = () => {
        updatePattern(id, pattern).then(res => {
            dispatch(updatePatternAction(res.data))
            closeTab()
            toast.success('Desen güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Desen Düzenle</label>
                <Input
                    label='Desen Kodu'
                    name='code'
                    value={pattern.code}
                    placeholder='Desen kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setPattern, setErrors)}
                />
                <Input
                    label='Desen Adı'
                    name='name'
                    value={pattern.name}
                    placeholder='Desen adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setPattern, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={pattern.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setPattern, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default PatternEditPage